const getProductList = (state) => {
    return state.productList
}

const getAgents = (state) => {
    return state.agents
}

const getCurrentAgent = (state) => {
    return state.currentAgent
}

export default {
    getProductList,
    getAgents,
    getCurrentAgent,
}